import React from "react";
import { Button } from "../../../../../design/button";
import { Field, Label } from "../../../../../design/fieldset";
import OnboardingContainer from "../../../components/OnboardingContainer";
import { Professional } from "../../../../../models/Professional";
import { Select } from "../../../../../design/select";
import SelectLanguagesField from "../../../../../components/Fields/SelectLanguagesField";

const supportedLanguages = [
  "English",
  "Spanish",
  "Mandarin",
  "French",
  "Arabic",
  "Russian",
  "Hindi",
  "Portuguese",
  "Other",
];

const OnboardingLanguagesSpokenStep: React.FC<{
  formData: Partial<Professional>;
  setFormData: React.Dispatch<React.SetStateAction<Partial<Professional>>>;
  onBack: () => void;
  onStepComplete: () => void;
}> = ({ formData, setFormData, onBack, onStepComplete }) => {
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onStepComplete();
  };

  return (
    <OnboardingContainer title="Languages Spoken">
      <>
        <form onSubmit={handleSubmit} className="space-y-6">
          <SelectLanguagesField
            title="Select Languages"
            values={formData.languagesSpoken || []}
            onChange={(values) =>
              setFormData({ ...formData, languagesSpoken: values })
            }
          />

          <div className="flex justify-between gap-4">
            <Button type="button" onClick={onBack}>
              Back
            </Button>
            <Button type="submit">Continue</Button>
          </div>
        </form>
      </>
    </OnboardingContainer>
  );
};

export default OnboardingLanguagesSpokenStep;
